namespace Ir.Components.Company.SelectCompanyPopover {
    interface ISelectCompanyPopoverViewModel {
        popoverConfig: DevExpress.ui.dxPopover.Properties;
        popoverComponent: DevExpress.ui.dxPopover;

        listConfig: DevExpress.ui.dxList.Properties;
        listComponent: DevExpress.ui.dxList;
    }

    interface ISelectCompanyPopoverParams {
        callback: Function;
        onCompanyClick: (id: number, name: string) => void;

        position: DevExpress.PositionConfig;
    }

    export function getViewModel(this: ISelectCompanyPopoverViewModel, params: ISelectCompanyPopoverParams) {
        this.listConfig = {
            keyExpr: 'company_id',
            displayExpr: 'company_name',
            searchEnabled: true,
            searchExpr: 'company_name',
            pageLoadMode: 'scrollBottom',
            onInitialized: function (this: ISelectCompanyPopoverViewModel, e) {
                this.listComponent = e.component;
            },
            onItemClick: function (this: ISelectCompanyPopoverViewModel, e) {
                params.onCompanyClick(e.itemData.company_id, e.itemData.company_name);
                this.popoverComponent.hide();
            }.bind(this),
        };

        this.popoverConfig = {
            title: "Company selection",
            showTitle: true,
            position: params.position ? params.position : "right",
            width: 300,
            visible: false,
            onShowing(e) {
                loadDataSource.call(this);
            },
            onInitialized: function (this: ISelectCompanyPopoverViewModel, e) {
                this.popoverComponent = e.component;
                if (params.callback && typeof params.callback === "function") {
                    params.callback({
                        show: function (this: ISelectCompanyPopoverViewModel, element) {
                            this.popoverComponent.show(element);
                        }.bind(this)
                    });
                }
            }.bind(this)
        };
    }

    function loadDataSource(this: ISelectCompanyPopoverViewModel) {
        let self = this;
        let o = {
            url: `${urlConfigs.tabs}GetUserCompanies/?mappingId=${workbook?.workbookConfig?.mappingId ?? 0}`,
            data: { },
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (result, e) {
            self.listComponent.option("dataSource", result);
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            self.listComponent.option("dataSource", []);
            errorItem.userMessage = "Failed to get companies";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }

}